module.exports = __webpack_public_path__ + "static/media/2.aa02e7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/certificaciones/2.png
// module id = 51
// module chunks = 0